/* ═══════════════════════════════════════════════════
   STREAMS AFTER 10TH — Indian Education Context
═══════════════════════════════════════════════════ */

const streams = [
  {
    id: "science",
    title: "Science (PCM / PCB)",
    emoji: "🔬",
    color: "#6C5CE7",
    gradient: "linear-gradient(135deg, #6C5CE7, #A29BFE)",
    tagline: "For curious minds who question everything",
    description:
      "The most versatile stream — Science opens doors to Engineering, Medicine, Research, Data Science, Aviation, Architecture and more. If you love understanding how things work, this is your launchpad.",
    subjects: {
      pcm: [
        "Physics",
        "Chemistry",
        "Mathematics",
        "English",
        "Computer Science / Economics",
      ],
      pcb: [
        "Physics",
        "Chemistry",
        "Biology",
        "English",
        "Psychology / Biotechnology",
      ],
      pcmb: [
        "Physics",
        "Chemistry",
        "Maths + Biology",
        "English",
        "(Most demanding but keeps all doors open)",
      ],
    },
    careers: [
      "Doctor",
      "Engineer",
      "Data Scientist",
      "AI Engineer",
      "Architect",
      "Pilot",
      "Researcher",
      "Pharmacist",
    ],
    advantages: [
      "Maximum career options — almost every field is accessible",
      "Eligible for both engineering (JEE) and medical (NEET) exams",
      "Strong foundation for higher studies abroad",
      "High-paying career paths in tech and medicine",
      "Can switch to Commerce/Arts careers later, but not vice versa",
    ],
    topExams: [
      "JEE Main/Advanced",
      "NEET",
      "BITSAT",
      "KVPY",
      "NTSE",
      "Olympiads",
    ],
    suitableFor:
      "Students who are strong in Maths and/or Biology, enjoy experiments, and want maximum career flexibility.",
    difficulty: 4,
  },
  {
    id: "commerce",
    title: "Commerce",
    emoji: "📊",
    color: "#FDCB6E",
    gradient: "linear-gradient(135deg, #FDCB6E, #F39C12)",
    tagline: "Master the world of money, business and markets",
    description:
      "Commerce is the gateway to business, finance, and entrepreneurship. From Chartered Accountancy to Investment Banking — if numbers, markets, and money excite you, this stream builds the perfect foundation.",
    subjects: {
      core: [
        "Accountancy",
        "Business Studies",
        "Economics",
        "English",
        "Mathematics / Informatics Practices",
      ],
    },
    careers: [
      "Chartered Accountant",
      "Investment Banker",
      "Financial Analyst",
      "Entrepreneur",
      "Company Secretary",
      "Economist",
      "Actuary",
    ],
    advantages: [
      "Direct path to CA, CS, CMA — India's most respected certifications",
      "Strong foundation for MBA and business careers",
      "Less pressure than Science stream for many students",
      "Growing demand in India's expanding financial sector",
      "Can start earning early through CA articleship",
    ],
    topExams: [
      "CA Foundation",
      "CS Foundation",
      "CUET",
      "CLAT (for law)",
      "IPM IIM Indore",
    ],
    suitableFor:
      "Students who like working with numbers, are organized, interested in business news, and want stable high-paying careers.",
    difficulty: 3,
  },
  {
    id: "arts",
    title: "Arts / Humanities",
    emoji: "📚",
    color: "#FF6B6B",
    gradient: "linear-gradient(135deg, #FF6B6B, #EE5A24)",
    tagline: "For thinkers, dreamers, and change-makers",
    description:
      "Arts is NOT a 'weak' stream — it's the powerhouse behind India's most influential leaders. From IAS officers to journalists, psychologists to filmmakers — Humanities shapes the people who shape society.",
    subjects: {
      core: [
        "History",
        "Political Science",
        "Geography / Psychology / Sociology",
        "English",
        "Economics / Fine Arts / Music",
      ],
    },
    careers: [
      "IAS/IPS Officer",
      "Lawyer",
      "Journalist",
      "Psychologist",
      "Historian",
      "Social Worker",
      "Filmmaker",
      "Politician",
      "Teacher/Professor",
    ],
    advantages: [
      "Best stream for UPSC Civil Services preparation",
      "Strong foundation for Law (BA LLB)",
      "Creative careers in media, film, and writing",
      "Growing field of Psychology and Social Sciences",
      "Less academic pressure — more time for extracurriculars",
      "Many scoring subjects in board exams",
    ],
    topExams: [
      "UPSC CSE",
      "CLAT",
      "NID",
      "NIFT",
      "CUET",
      "Mass Communication entrances",
    ],
    suitableFor:
      "Students who love reading, writing, debating, and are interested in society, history, politics, or creative fields.",
    difficulty: 2,
  },
  {
    id: "diploma",
    title: "Diploma (Polytechnic)",
    emoji: "⚙️",
    color: "#00B894",
    gradient: "linear-gradient(135deg, #00B894, #00CEC9)",
    tagline: "Hands-on skills that get you job-ready fast",
    description:
      "Diploma courses after 10th give you practical, job-ready skills in just 3 years. You can start earning earlier than your peers AND still get a degree later through lateral entry to B.Tech.",
    subjects: {
      branches: [
        "Computer Engineering",
        "Mechanical Engineering",
        "Electrical Engineering",
        "Civil Engineering",
        "Electronics",
        "Automobile Engineering",
      ],
    },
    careers: [
      "Junior Engineer",
      "Technician",
      "Site Supervisor",
      "Lab Technician",
      "Freelance Developer",
      "Entrepreneur in technical services",
    ],
    advantages: [
      "Start working 3 years earlier than B.Tech graduates",
      "Lateral entry to B.Tech 2nd year after diploma",
      "Practical, hands-on learning from day one",
      "Government jobs available through SSC JE, Railway JE",
      "Lower cost than 4-year degree programs",
      "High demand for skilled technicians in India",
    ],
    topExams: ["State Polytechnic Entrance (CET)", "JEECUP (UP)", "Delhi CET"],
    suitableFor:
      "Students who prefer practical learning over theory, want to start earning early, or plan to do B.Tech through lateral entry.",
    difficulty: 2,
  },
  {
    id: "iti",
    title: "ITI (Industrial Training)",
    emoji: "🔧",
    color: "#636E72",
    gradient: "linear-gradient(135deg, #636E72, #2D3436)",
    tagline: "Learn a trade, earn a living, build a career",
    description:
      "ITI (Industrial Training Institute) courses focus on specific trades and vocational skills. In 1-2 years, you become skilled in a trade that has immediate job demand — from electrician to web designer.",
    subjects: {
      trades: [
        "Electrician",
        "Fitter",
        "Welder",
        "Computer Operator (COPA)",
        "Draughtsman",
        "Mechanic Motor Vehicle",
        "Plumber",
        "Turner",
      ],
    },
    careers: [
      "Skilled Tradesperson",
      "Railway/Government Technician",
      "Self-employed Contractor",
      "Factory Supervisor",
      "Maintenance Engineer",
    ],
    advantages: [
      "Shortest path to employment (1-2 years)",
      "Very affordable — government ITIs are nearly free",
      "Direct recruitment in Railways, Defence, PSUs",
      "Self-employment opportunities — start your own workshop",
      "Apprenticeship programs in top companies",
      "Can continue education later (diploma, degree)",
    ],
    topExams: [
      "ITI CET (State level)",
      "NCVT certification",
      "Apprenticeship exams",
    ],
    suitableFor:
      "Students who want to learn practical trades quickly, prefer working with hands, or need to start earning early due to financial constraints.",
    difficulty: 1,
  },
];

export default streams;
